import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Box, Typography, Divider, Avatar } from "@mui/material";
import {
  GridViewOutlined,
  FolderOutlined,
  LinkOutlined,
  ViewAgendaOutlined,
  AssignmentOutlined,
  SubjectOutlined,
  GroupsOutlined,
} from "@mui/icons-material";
import sidebarIcon from "../../assets/images/sidebarIcon.jpg";
import star from "../../assets/images/star.png";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleSidebar = () => setIsOpen(!isOpen);

  const menuItems = [
    { path: "/", name: "Dashboard", icon: <GridViewOutlined sx={{ fontSize: "18px" }} /> },
    { path: "/customer-rooms", name: "Customer Rooms", icon: <LinkOutlined sx={{ transform: "rotate(-20deg)", fontSize: "18px" }} /> },
    { path: "/files-manager", name: "Files Manager", icon: <FolderOutlined sx={{ fontSize: "18px" }} /> },
    { path: "/templates", name: "Manage Templates", icon: <ViewAgendaOutlined sx={{ fontSize: "18px" }} /> },
    { path: "/notes", name: "Notes", icon: <SubjectOutlined sx={{ fontSize: "18px" }} /> },
    { path: "/tasks", name: "Tasks", icon: <AssignmentOutlined sx={{ fontSize: "18px" }} /> },
  ];

  const templates = [
    { path: "/templates/1", name: "New Workplace", icon: <ViewAgendaOutlined sx={{ fontSize: "14px" }} /> },
    { path: "/templates/2", name: "Divorce Case", icon: <ViewAgendaOutlined sx={{ fontSize: "14px" }} /> },
    { path: "/templates/3", name: "New Workplace", icon: <ViewAgendaOutlined sx={{ fontSize: "14px" }} /> },
  ];

  const manage = [
    { path: "/tasks-dashboard", name: "Tasks Dashboard", icon: <GridViewOutlined sx={{ fontSize: "14px" }} /> },
    { path: "/manage-teams", name: "Manage Teams", icon: <GroupsOutlined sx={{ fontSize: "14px" }} /> },
  ];

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#fffff",
        boxShadow: 1,
        transition: "width 0.3s",
        width: isOpen ? 220 : 70,
        padding: "8px",
        overflowY: "auto",
        paddingTop: "0px",
      }}
    >
      {/* Sidebar Photo Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          paddingY: 1,
          backgroundColor: "#FFFFFF",
          cursor: "pointer",
          width: isOpen ? 200 : 60,
          height: "56px",
          
        }}
        onClick={toggleSidebar}
      >
        {
          isOpen ? (
            <img  src={sidebarIcon} alt="Sidebar Icon" style={{ width: "90%", height: "40px",alignSelf:'flex-start'}} />
          )
          :(
            <img  src={star} alt="Sidebar Icon" style={{ width: "30px", height: "30px",alignSelf:'flex-start'}} />
          )
          
        }
        
      </Box>

      {/* Menu Items */}
      <Box sx={{ flex: 1, mt: 2 }}>
        {menuItems.map((item, index) => (
          <NavLink
            to={item.path}
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              marginBottom: 8,
              fontSize: "14px",
            }}
            className={({ isActive }) =>
              `flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                isActive
                  ? "bg-primary text-white"
                  : "text-gray-700 hover:bg-gray-200"
              }`
            }
          >
            <Box
              sx={{
                fontSize: "18px",
                mr: isOpen ? 2 : 0,
                color: ({ isActive }) => (isActive ? "#FFFFFF" : "inherit"),
                display: "flex",
                alignItems: "center",
              }}
            >
              {item.icon}
            </Box>
            {isOpen && <Typography variant="body2">{item.name}</Typography>}
          </NavLink>
        ))}
      </Box>

      {/* Divider and Templates Section */}
      <Divider sx={{ my: 1, mx: 2 }} />
      <Box sx={{ px: 2 }}>
        {isOpen && (
          <Typography
            variant="caption"
            color="textSecondary"
            sx={{ fontWeight: "bold", textTransform: "uppercase", mb: 0.5 }}
          >
            Templates
          </Typography>
        )}
        <Box sx={{ mt: 0.5 }}>
          {templates.map((template, index) => (
            <NavLink
              to={template.path}
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                marginBottom: 8,
                fontSize: "14px",
              }}
              className={({ isActive }) =>
                `flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                  isActive
                    ? "bg-primary text-white"
                    : "text-gray-700 hover:bg-gray-200"
                }`
              }
            >
              <Box
                sx={{
                  fontSize: "14px",
                  mr: isOpen ? 2 : 0,
                  color: ({ isActive }) => (isActive ? "#FFFFFF" : "inherit"),
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {template.icon}
              </Box>
              {isOpen && <Typography variant="body2">{template.name}</Typography>}
            </NavLink>
          ))}
        </Box>
      </Box>

      {/* Divider and Manage Section */}
      <Divider sx={{ my: 1, mx: 2 }} />
      <Box sx={{ px: 2 }}>
        {isOpen && (
          <Typography
            variant="caption"
            color="textSecondary"
            sx={{ fontWeight: "bold", textTransform: "uppercase", mb: 0.5 }}
          >
            Manage
          </Typography>
        )}
        <Box sx={{ mt: 0.5 }}>
          {manage.map((item, index) => (
            <NavLink
              to={item.path}
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                marginBottom: 8,
                fontSize: "14px",
              }}
              className={({ isActive }) =>
                `flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                  isActive
                    ? "bg-primary text-white"
                    : "text-gray-700 hover:bg-gray-200"
                }`
              }
            >
              <Box
                sx={{
                  fontSize: "14px",
                  mr: isOpen ? 2 : 0,
                  color: ({ isActive }) => (isActive ? "#FFFFFF" : "inherit"),
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {item.icon}
              </Box>
              {isOpen && <Typography variant="body2">{item.name}</Typography>}
            </NavLink>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Sidebar;
